import React from "react"
import { Global, css } from "@emotion/core"
import CookieBg from '../../assets/bg-cookie-bot.png';
import CookieIcon from '../../assets/info-icon.svg';

export const themeColor = {
    white: "#FFFFFF",
    black: "#000000",
    yellow: "#FCEE0A",
    red: "#FD0130",
    cyan: "#02D8F3",
    lightGrey: "#CBCBCB",
    darkGrey: "#8B8B8B",
};

export const themeDefault = {

	idlePrimary: themeColor.white,
    idleSecondary: themeColor.red,
    idleInvert: themeColor.black,
    disabled: themeColor.darkGrey,
    hovered: themeColor.red,
    pressed: themeColor.red,

    fontPrimary: themeColor.black,
    fontSecondary: themeColor.lightGrey,
};

export default ({bgColor=themeColor.black}) => (
    <Global
        styles={css`
            html, body, #___gatsby, #gatsby-focus-wrapper {
                background: ${bgColor};
                color: white;

                margin: 0;
                padding: 0;
                overflow: hidden;
                width: 100%;
                height: 100% ;   
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 700;
                position: fixed;
            }
            img {
                margin: auto;
                padding: 0;   
            }
             
            button {
                cursor: pointer;
                &:disabled {
                    cursor: not-allowed  !important;
                }
            }

            body #CybotCookiebotDialog {
                background-color: #fff;
                border: 1px solid #91a198;
                box-shadow: 0px 20px 32px rgba(63, 101, 97, 0.3);
                backdrop-filter: blur(32px);
                max-width: 624px;
                border-radius: 0;
            }

            body #CybotCookiebotDialog div {
                font-family: ff-good-web-pro-condensed, sans-serif;
                line-height: unset;
            }

            body #CybotCookiebotDialog div:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialog div:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialog div:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialog:after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-image: url(${CookieBg});
                background-repeat: no-repeat;
                background-size: 60% auto;
                background-position: left -30px;
                z-index: -1;
            }

            @media screen and (max-width: 540px) {
                body #CybotCookiebotDialog:after {
                    background-size: 80% auto;
                }
            }

            body #CybotCookiebotDialogPoweredbyLink {
                display: none;
            }

            body #CybotCookiebotDialogBodyContent {
                padding-left: 72px;
                padding-right: 32px;
                padding-bottom: 16px;
                padding-top: 28px;
            }

            body #CybotCookiebotDialogBodyContentTitle {
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 700;
                font-size: 22px;
                line-height: 24px;
                color: #000 !important;
                position: relative;
            }

            body #CybotCookiebotDialogBodyContentTitle:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialogBodyContentTitle:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialogBodyContentTitle:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogBodyContentTitle:before {
                content: '';
                position: absolute;
                top: -6px;
                left: -48px;
                width: 32px;
                height: 32px;
                background-image: url(${CookieIcon});
                background-repeat: no-repeat;
                background-size: auto 100%;
                background-position: center center;
            }

            body #CybotCookiebotDialogBodyContentText {
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px !important;
                color: #000 !important;
                margin-bottom: 0;
            }

            body #CybotCookiebotDialogBodyContentText:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialogBodyContentText:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialogBodyContentText:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonAccept {
                background-color: #e60000 !important;
                margin-left: 0;
                margin-right: 0;
                font-size: 18px;
                line-height: 18px;
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 700;
                color: #fff !important;
                min-width: 118px;
                padding-top: 12px;
                padding-bottom: 12px;
                margin-top: 0;
                border: 0;
                padding-left: 0 !important;
                padding-right: 0 !important;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonAccept:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonAccept:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonAccept:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonDetails {
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
                color: #000 !important;
                background-position: 104px 15px;
                min-width: 100px;
            }

            @media not all and (min-resolution: 0.001dpcm) {
                @supports (-webkit-appearance: none) {
                    background-position: 104px 15px;
                }
            }
            @media screen and (max-width: 540px) {
                body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonDetails {
                    background-position: 104px 15px;
                }
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonDetails:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonDetails:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialogBodyButtons #CybotCookiebotDialogBodyButtonDetails:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogDetail, body #CybotCookiebotDialogDetailBodyContentTabsAbout, body #CybotCookiebotDialogDetailBodyContentTabsOverview, body #CybotCookiebotDialogDetailFooter {
                background-color: rgba(0, 0, 0, 0) !important;
                color: #000 !important;
            }

            body #CybotCookiebotDialogDetailBodyContentTabsOverview.CybotCookiebotDialogDetailBodyContentTabsItemSelected, body #CybotCookiebotDialogDetailBodyContentTabsAbout.CybotCookiebotDialogDetailBodyContentTabsItemSelected {
                background-color: rgba(0, 0, 0, 0.1) !important;
            }

            body #CybotCookiebotDialog, body #CybotCookiebotDialogBodyContentTitle, body #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyLink, body #CybotCookiebotDialogBodyLevelDetailsButton, body #CybotCookiebotDialogDetailBodyContent, body #CybotCookiebotDialog a, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable tbody td, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable thead th, body a.CybotCookiebotDialogDetailBodyContentTabsItemSelected, body .CybotCookiebotDialogDetailBodyContentCookieContainerTypes, body .CybotCookiebotDialogDetailBodyContentIABv2Tab, body .CybotCookiebotDialogDetailBodyContentCookieContainerTypesSelected, body .CybotCookiebotDialogDetailBodyContentIABv2TabSelected, body #CybotCookiebotDialogDetailFooter {
                color: #000 !important;
            }

            body #CybotCookiebotDialog:hover, body #CybotCookiebotDialogBodyContentTitle:hover, body #CybotCookiebotDialogBodyButtons .CybotCookiebotDialogBodyLink:hover, body #CybotCookiebotDialogBodyLevelDetailsButton:hover, body #CybotCookiebotDialogDetailBodyContent:hover, body #CybotCookiebotDialog a:hover, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable tbody td:hover, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable thead th:hover, body a.CybotCookiebotDialogDetailBodyContentTabsItemSelected:hover, body .CybotCookiebotDialogDetailBodyContentCookieContainerTypes:hover, body .CybotCookiebotDialogDetailBodyContentIABv2Tab:hover, body .CybotCookiebotDialogDetailBodyContentCookieContainerTypesSelected:hover, body .CybotCookiebotDialogDetailBodyContentIABv2TabSelected:hover, body #CybotCookiebotDialogDetailFooter:hover {
                color: #000 !important;
            }

            body .CybotCookiebotDialogDetailBodyContentTabsItemSelected, body #CybotCookiebotDialogDetailBodyContentCookieContainerTypes {
                background: rgba(0, 0, 0, 0) !important;
            }

            body .CybotCookiebotDialogDetailBodyContentTabsItem {
                background: rgba(0, 0, 0, 0.1) !important;
            }

            body a.CybotCookiebotDialogDetailBodyContentTabsItem:focus, body a.CybotCookiebotDialogDetailBodyContentTabsItem:hover {
                background: rgba(0, 0, 0, 0.2) !important;
            }

            body .CybotCookiebotDialogDetailBodyContentCookieContainerTypesSelected, body .CybotCookiebotDialogDetailBodyContentIABv2TabSelected {
                background: rgba(0, 0, 0, 0) !important;
            }

            body .CybotCookiebotDialogDetailBodyContentCookieContainerTypes, body .CybotCookiebotDialogDetailBodyContentIABv2Tab {
                background: rgba(0, 0, 0, 0.1) !important;
            }

            body .CybotCookiebotDialogDetailBodyContentCookieTypeTable tbody td, body #CybotCookiebotDialog a, body #CybotCookiebotDialogDetailBodyContentCookieContainerTypes {
                color: #000 !important;
                background-color: rgba(0, 0, 0, 0) !important;
            }

            body .CybotCookiebotDialogDetailBodyContentCookieTypeTable tbody td:hover, body #CybotCookiebotDialog a:hover, body #CybotCookiebotDialogDetailBodyContentCookieContainerTypes:hover {
                color: #000 !important;
            }

            body #CybotCookiebotDialog a.CybotCookiebotDialogDetailBodyContentCookieContainerTypes:focus, body #CybotCookiebotDialog a.CybotCookiebotDialogDetailBodyContentCookieContainerTypes:hover, body #CybotCookiebotDialog a.CybotCookiebotDialogDetailBodyContentIABv2Tab:focus, body #CybotCookiebotDialog a.CybotCookiebotDialogDetailBodyContentIABv2Tab:hover {
                background: rgba(0, 0, 0, 0.2) !important;
                color: #000;
            }

            body #CybotCookiebotDialogDetail, body #CybotCookiebotDialogDetailBodyContentTabs a, body #CybotCookiebotDialogDetailBodyContentCookieContainerTypeDetails, body #CybotCookiebotDialogDetailBodyContentIABv2Details, body #CybotCookiebotDialogDetailBodyContent a, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable tbody td, body #CybotCookiebotDialogDetailBodyContentTextAbout {
                font-size: 13px;
            }

            body #CybotCookiebotDialog a {
                font-family: ff-good-web-pro-condensed, sans-serif;
            }

            body #CybotCookiebotDialog a:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialog a:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialog a:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogDetailBodyContent {
                background: rgba(0, 0, 0, 0) !important;
                border-bottom: 2px solid #ccc;
            }

            body .CybotCookiebotDialogDetailBodyContentCookieTypeTable thead td, body .CybotCookiebotDialogDetailBodyContentCookieTypeTable thead th {
                background: rgba(0, 0, 0, 0.2) !important;
            }

            body a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll {
                background-color: #000;
                border: none;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll, body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection, body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll {
                font-size: 16px;
                line-height: 16px;
                font-family: ff-good-web-pro-condensed, sans-serif;
                font-weight: 700;
                min-width: 118px;
                border: 0;
                padding: 10px 5px;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll:lang(zh-cn), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection:lang(zh-cn), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll:lang(zh-cn) {
                font-family: 'Noto Sans SC', sans-serif;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll:lang(zh-tw), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection:lang(zh-tw), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll:lang(zh-tw) {
                font-family: 'Noto Sans TC', sans-serif;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll:lang(ko), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection:lang(ko), body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll:lang(ko) {
                font-family: 'Nanum Myeongjo', serif;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowAll, body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelection {
                background-color: #e60000 !important;
                color: #fff !important;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper a#CybotCookiebotDialogBodyLevelButtonLevelOptinDeclineAll {
                background-color: #333 !important;
                color: #fff !important;
            }

            body #CybotCookiebotDialogBodyLevelDetailsWrapper {
                background-color: transparent;
            }

            body #CybotCookiebotDialogBodyLevelButtonLevelOptinAllowallSelectionWrapper {
                padding-bottom: 10px;
            }

            body .tingle-modal {
                z-index: 1050;
            }

            body .tingle-modal-box {
                background: #000;
                border: 1px solid #e90c15;
                border-radius: 0;
                color: #fff;
            }

            body .tingle-modal-box a:link, body .tingle-modal-box a:visited {
                color: #fff;
            }

            body .CookieDeclarationType, body .CookieDeclarationTableCell {
                border-color: #fff;
            }
        `}
    />
)
